import { WebUrl } from "shared-web/lib/webUrl"

export function adminReconciliation(): WebUrl {
  return {
    pathname: "/admin/reconciliation",
  }
}
